export { default } from "./useTeacherUpdate";
